// extracted by mini-css-extract-plugin
export default {"content":"Catalog-module__content--NrHn3"};